import type { ThreadAccountSchedule, ThreadAccountPostReservation } from '../api/types';

export const autoPublishChannels = [
  { key: 'youtubeEnabled', label: '유튜브' },
  { key: 'productEnabled', label: '소재' },
  { key: 'notionEnabled', label: '노션' },
  { key: 'personaEnabled', label: '페르소나' },
] as const;
export type AutoPublishKey = typeof autoPublishChannels[number]['key'];
export type AutoPublishChannels = Record<AutoPublishKey, boolean>;
export function channelsFromSchedule(schedule?: ThreadAccountSchedule | null): AutoPublishChannels {
  return {
    personaEnabled: schedule?.personaEnabled ?? false, productEnabled: schedule?.productEnabled ?? false,
    youtubeEnabled: schedule?.youtubeEnabled ?? false, notionEnabled: schedule?.notionEnabled ?? false,
  };
}
export function reservationKind(task: ThreadAccountPostReservation): typeof autoPublishChannels[number]['label'] {
  if (task.source === 'NOTION' || task.notionPageId) return '노션';
  if (task.publishMode === 'YOUTUBE' || task.youtubeTopicId != null) return '유튜브';
  if (task.publishMode === 'PRODUCT' || task.productId != null) return '소재';
  return '페르소나';
}
